import { render, staticRenderFns } from "./ReportCoverPage.vue?vue&type=template&id=6d131d59&scoped=true&"
import script from "./ReportCoverPage.vue?vue&type=script&lang=ts&"
export * from "./ReportCoverPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportCoverPage.vue?vue&type=style&index=0&id=6d131d59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d131d59",
  null
  
)

export default component.exports